import React, { useEffect, useState } from "react";
import AddBaseModal from "../../../../../components/add-base-modal/AddBaseModal";
import { showMessage, useApi } from "../../../../../services/helpers";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";

const stripePromise = loadStripe("pk_test_your_publishable_key");

const PaymentModal = ({ open, onClose, requestedOrder, projectId }) => {
  const api = useApi();
  const [clientSecret, setClientSecret] = useState(null);
  const [loading, setLoading] = useState(false);
  const [smStripeWarning, setSmStripeWarning] = useState(null);

  // determine if any product in requestedOrder has stripe enabled
  const isStripeEnabled = React.useMemo(() => {
    if (!requestedOrder?.sections || requestedOrder.sections.length === 0) return false;
    return requestedOrder.sections.some(section =>
      section?.lines && section.lines.some(line => line?.product?.stripe_enabled === true)
    );
  }, [requestedOrder]);

  console.log("requestedOrder FULL:", JSON.stringify(requestedOrder, null, 2));

  console.log("PaymentModal props:", { open, requestedOrder });
  console.log("Rendering Elements?", {
    loading,
    clientSecret,
    stripePromise,
  });

  useEffect(() => {
    if (open) {
      setSmStripeWarning(null);
      createPaymentIntent();
    }
  }, [open]);

  const createPaymentIntent = async () => {
    if (!requestedOrder?.id) return;

    setLoading(true);

    try {
      const result = await api.createPaymentIntent(
        projectId,
        requestedOrder,
        requestedOrder.id
      );

      if (result.kind === "ok") {
        setClientSecret(result.data.client_secret);
      } else {
        const d = result.errors ?? result.data;
        if (d?.sm_stripe_error) {
          setSmStripeWarning(d.detail);
        } else {
          const msg = typeof d === 'string' ? d
            : Array.isArray(d) ? d[0]
            : d?.detail || d?.non_field_errors?.[0]
            || (d && typeof d === 'object' ? Object.values(d).flat()[0] : null)
            || "Payment setup failed. Please try again.";
          showMessage(msg, 'warning');
          onClose();
        }
      }
    } catch (error) {
      showMessage("Payment setup failed. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AddBaseModal
      open={open}
      handleClose={onClose}
      showActions={false}
      modalContainer={{ width: 650 }}
    >
      <MDBox p={3} minHeight={300}>
        {loading && <MDTypography>Preparing secure payment...</MDTypography>}

        {!loading && smStripeWarning && (
          <MDBox
            sx={{
              p: "14px 16px",
              borderRadius: "8px",
              bgcolor: "#fff8e1",
              border: "1px solid #ffe082",
              display: "flex",
              flexDirection: "column",
              gap: "6px",
            }}
          >
            <MDTypography variant="body2" fontWeight="bold" sx={{ color: "#7a5a00" }}>
              ⚠️ Payment unavailable
            </MDTypography>
            <MDTypography variant="caption" sx={{ color: "#7a5a00", lineHeight: 1.6 }}>
              {smStripeWarning}
            </MDTypography>
          </MDBox>
        )}

        {!loading && !smStripeWarning && !isStripeEnabled && (
          <MDTypography color="error">
            Payment is not available because no products support Stripe.
          </MDTypography>
        )}

        {!loading && !smStripeWarning && clientSecret && isStripeEnabled && (
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <CheckoutForm clientSecret={clientSecret} onSuccess={onClose} />
          </Elements>
        )}
      </MDBox>
    </AddBaseModal>
  );
};

export default PaymentModal;
